<template>
  <footer class="main-footer">
    <strong>Copyright &copy; 2018 <a href="http://www.ojssymphonique.net/fr">OJS</a>.</strong> Tous droits réservés.
  </footer>
</template>

<script>
  export default {
    name: 'DashboardFooter'
  }
</script>



// WEBPACK FOOTER //
// Footer.vue?5b106b47